import React, { PureComponent } from "react";
import "./style.css";
import { Container, Row } from "shards-react";
import PageTitle from "../../components/common/PageTitle";
import { Layout } from "antd";
import { SideBar } from "./SideBar";
import CreateCategory from "./Pages/Category/CreateCategory";
import PreviewAllCategories from "./Pages/Category/PreviewAllCategories";
import UpdateCategory from "./Pages/Category/UpdateCategory";
import CreateOffer from "./Pages/Offer/CreateOffer";
import UpdateOffer from "./Pages/Offer/UpdateOffer";
import PreviewAllOffers from "./Pages/Offer/PreviewAllOffers";
import CreateUser from "./Pages/User/CreateUser";
import UpdateUser from "./Pages/User/UpdateUser";
import PreviewAllUsers from "./Pages/User/PreviewAllUsers";
import CreateLifeInsurance from "./Pages/LifeInsurance/CreateLifeInsurance";
import UpdateLifeInsurance from "./Pages/LifeInsurance/UpdateLifeInsurance";
import PreviewAllLifeInsurance from "./Pages/LifeInsurance/PreviewAllLifeInsurance";
import CreateCarInsurance from "./Pages/CarInsurance/CreateCarInsurance";
import UpdateCarInsurance from "./Pages/CarInsurance/UpdateCarInsurance";
import PreviewAllCarInsurance from "./Pages/CarInsurance/PreviewAllCarInsurance";
import CreateMedicalInsurance from "./Pages/MedicalInsurance/CreateMedicalInsurance";
import UpdateMedicalInsurance from "./Pages/MedicalInsurance/UpdateMedicalInsurance";
import PreviewAllMedicalInsurance from "./Pages/MedicalInsurance/PreviewAllMedicalInsurance";
import CreateNotification from "./Pages/Notification/CreateNotification";
import UpdateNotification from "./Pages/Notification/UpdateNotification";
import PreviewAllNotifications from "./Pages/Notification/PreviewAllNotifications";
import CreateFeedback from "./Pages/Feedback/CreateFeedback";
import PreviewAllFeedbacks from "./Pages/Feedback/PreviewAllFeedbacks";
import MailConfiguration from "./Pages/Feedback/MailConfiguration";
const { Content } = Layout;
class Settings extends PureComponent {
  state = { selectedTab: "co" };

  componentDidMount() {}

  onSelectTabChange = (value) => {
    this.setState({ selectedTab: value.key });
  };

  selectTab = () => {
    switch (this.state.selectedTab) {
      case "co": {
        return <CreateCategory />;
      }

      case "pao": {
        return <PreviewAllCategories />;
      }

      case "uao": {
        return <UpdateCategory />;
      }

      case "cc": {
        return <CreateOffer />;
      }
      case "uec": {
        return <UpdateOffer />;
      }

      case "ec": {
        return <PreviewAllOffers />;
      }

      case "cu": {
        return <CreateUser />;
      }

      case "eu": {
        return <UpdateUser />;
      }

      case "pau": {
        return <PreviewAllUsers />;
      }

      case "lcd": {
        return <CreateLifeInsurance />;
      }

      case "led": {
        return <UpdateLifeInsurance />;
      }

      case "lad": {
        return <PreviewAllLifeInsurance />;
      }

      case "cicd": {
        return <CreateCarInsurance />;
      }

      case "cied": {
        return <UpdateCarInsurance />;
      }

      case "ciad": {
        return <PreviewAllCarInsurance />;
      }

      case "mcc": {
        return <CreateMedicalInsurance />;
      }

      case "mec": {
        return <UpdateMedicalInsurance />;
      }

      case "mac": {
        return <PreviewAllMedicalInsurance />;
      }

      case "sn": {
        return <CreateNotification />;
      }

      case "en": {
        return <UpdateNotification />;
      }

      case "an": {
        return <PreviewAllNotifications />;
      }
      case "sf": {
        return <CreateFeedback />;
      }
      case "mailconfig": {
        return <MailConfiguration />;
      }
      case "pf": {
        return <PreviewAllFeedbacks />;
      }
      default:
        return;
    }
  };

  render() {
    return (
      <Container fluid className="main-content-container px-4 pb-3">
        {/* Page Header */}
        <Row noGutters className="page-header py-4">
          <PageTitle
            sm="6"
            title="Administration"
            subtitle=""
            className="text-sm-left"
          />
        </Row>
        <Layout className="site-layout-background" style={{ padding: "0" }}>
          <SideBar
            selectedTab={this.state.selectedTab}
            onSelectTabChange={this.onSelectTabChange}
          />
          <Content
            className="bg-white"
            style={{ padding: "0 24px", minHeight: 600 }}
          >
            {this.selectTab()}
          </Content>
        </Layout>
      </Container>
    );
  }
}

export default Settings;
